export default async function fetchBrandCarouselData(parameter: any) {
    try{

        const endpointurl = `/api/v1/GetBrandsByLocation?id=${parameter?.properties.dealerId}`;
        const response = await fetch(endpointurl);
        return response;
    }
    catch (error) {
        throw error;
    }
    
}

